import axios from "axios";
import { URL_AKM } from "../config";
import { configureSessionClient } from "./apiSession";

export default configureSessionClient(axios.create({
  baseURL: URL_AKM.AKM_HOST,
  headers: { Accept: "application/json", "Content-Type": "application/json" }
}));
